/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './submitPlcOperation.defs.js'
export * as $defs from './submitPlcOperation.defs.js'
